import { useSelector } from "react-redux";

import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Alert,
  Typography,
} from "@mui/material";

import { Link } from "components/html/Link";
import { LegacyFeedbackCard } from "views/Home/LegacyFeedbackCard";

import { i18n } from "services/i18nService";

import { formatDistanceToNowStrict } from "date-fns";

const sx = {
  display: "grid",
  minWidth: "1070px",
  "& a": { color: "primaryLink" },
};

export function Home() {
  const {
    company: { status, expirationDate },
  } = useSelector((state) => state.userCompanySettings);

  const isTrial = status === "Trial";
  const days = formatDistanceToNowStrict(new Date(expirationDate), {
    unit: "day",
  });

  return (
    <Box sx={sx} m={2} mb={0} data-testing="homePage">
      {isTrial && (
        <Alert sx={{ mb: 1, maxWidth: 600 }} severity="info">
          {i18n("home.trial.1")} {days} {i18n("home.trial.2")}{" "}
          <a href={"/accountInformation"}>{i18n("home.trial.3")}</a>
        </Alert>
      )}
      <Box mb={1}>
        <Typography variant="h2">{i18n("home.live.header")}</Typography>
      </Box>
      <Card variant="outlined" sx={{ maxWidth: 600 }}>
        <CardHeader title={i18n("home.live.title")} />
        <CardContent>
          <Typography>{i18n("home.live.p1")}</Typography>
          <ul>
            <li>{i18n("home.live.bullet.1")}</li>
            <li>{i18n("home.live.bullet.2")}</li>
            <li>{i18n("home.live.bullet.3")}</li>
            <li>{i18n("home.live.bullet.4")}</li>
            <li>{i18n("home.live.bullet.5")}</li>
            <li>{i18n("home.live.bullet.6")}</li>
            <li>{i18n("home.live.bullet.7")}</li>
            <li>{i18n("home.live.bullet.8")}</li>
            <li>{i18n("home.live.bullet.9")}</li>
          </ul>
          <Typography>
            {i18n("home.live.p2.1")}{" "}
            <Link
              component="a"
              rel="noreferrer"
              href="https://help.sosinventory.com/"
              target="_blank"
            >
              {" "}
              {i18n("home.live.p2.2")}
            </Link>{" "}
            {i18n("home.live.p2.3")}
          </Typography>
          <Typography>{i18n("home.live.p5")}</Typography>
        </CardContent>
      </Card>
      <LegacyFeedbackCard />
      <Card variant="outlined" sx={{ maxWidth: 600, mt: "1rem", mb: "1rem" }}>
        <CardHeader title={i18n("home.help.title")} />
        <CardContent>
          <Typography>
            {i18n("home.help.p1.1")}{" "}
            <Link component="a" href="mailto:support@sosinventory.com">
              support@sosinventory.com
            </Link>
            {i18n("home.help.p1.2")}{" "}
            <Link to="/Help/Contact">{i18n("home.help.p1.3")}</Link>{" "}
            {i18n("home.help.p1.4")}
          </Typography>
          <br />
          <Typography>
            {i18n("home.help.p2.1")}{" "}
            <Link component="a" href="mailto:support@sosinventory.com">
              support@sosinventory.com
            </Link>{" "}
            {i18n("home.help.p2.2")}
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}
